import { z } from "zod";
import { timestampsSchema } from "./common";
import { listQueryBaseSchema } from "./list-query";
import { REVIEW_STATUS } from "../constants/status";

export const reviewDtoSchema = z
  .object({
    id: z.string().uuid(),
    userId: z.string().uuid().nullable(),
    activityId: z.string().uuid().nullable(),
    comboId: z.string().uuid().nullable(),
    reservationId: z.string().uuid().nullable(),
    review: z.string(),
    rating: z.number().int().min(1).max(5),
    status: z.enum(REVIEW_STATUS),
    rejectionReason: z.string().nullable(),
    fullName: z.string().nullable(),
    email: z.string().nullable(),
    /**
     * Denormalised labels for the linked activity / combo. The reviews list is
     * unreadable without them — a bare uuid tells an admin nothing about what
     * was actually reviewed.
     */
    activityTitle: z.string().nullable(),
    activitySlug: z.string().nullable(),
    comboName: z.string().nullable(),
    comboSlug: z.string().nullable(),
  })
  .extend(timestampsSchema.shape);
export type ReviewDTO = z.infer<typeof reviewDtoSchema>;

export const reviewUpdateSchema = z.object({
  review: z.string().min(1).optional(),
  rating: z.number().int().min(1).max(5).optional(),
});
export type ReviewUpdateInput = z.infer<typeof reviewUpdateSchema>;

export const reviewRejectSchema = z.object({
  reason: z.string().min(1),
});
export type ReviewRejectInput = z.infer<typeof reviewRejectSchema>;

export const reviewsListQuerySchema = listQueryBaseSchema.extend({
  status: z.enum(REVIEW_STATUS).optional(),
  activityId: z.string().uuid().optional(),
  comboId: z.string().uuid().optional(),
  rating: z.coerce.number().int().min(1).max(5).optional(),
});
export type ReviewsListQuery = z.infer<typeof reviewsListQuerySchema>;
